<template>
    <div>
        <h1 
            class="fs-4 fw-bold text-dark mb-1 lh-sm"
        >
            Reglas de stock
        </h1>
        <p
            class="text-muted small fw-medium"
        >
            Define umbrales de quiebre y sobrestock, y qué acción de precio tomar automáticamente.
        </p>
        <TableStockConfig 
            @getData="getSearch"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @viewModal="viewModal"
            @filterStockStatus="updateStockStatus"
            :products="productList"
            :loading="loading"
            :total-count="totalProducts"
            :current-page="currentPage"
            :page-size="pageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import configsRecModuleMixin from '../mixins/configsRecModuleMixin';
import TableStockConfig from './TableStockConfig.vue';
import ModalForm from "../../../../../components/modal.vue";
import ConfigStockOne from './configStockOne.vue';
import ConfigStockOptions from './configStockOptions.vue';

export default {
    name: 'config-stock',
    mixins: [configsRecModuleMixin],
    components: {
        TableStockConfig,
        ModalForm,
        ConfigStockOne,
        ConfigStockOptions
    },
    data() {
        return {
            propHead: {
                action: "",
                open: false,
                module: "stock",
                text : ""
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
            stockStatus: '',
        };
    },
    methods: {
        ...mapActions(["executeCommit"]),
        buildUrl() {
            return `/api/products/list_config_stock/?${this.buildCommonParams()}&stock_status=${this.stockStatus}&prop_extra_3=VIGENTE`;
        },
        viewModal(row, name, title, text) {
            this.componentName = name;
            this.propForm.size = false
            this.propHead = {
                action: title,
                open: true,
                row: row,
                text: text,
                component: this.componentName,
            }
        },
        closeModal() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.propHead = {
                action: "",
                open: false,
                module: "stock",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
            this.fetchData();
        },
        updateStockStatus(status) {
            this.stockStatus = status;
            this.fetchData();
        },
    }
}
</script>
